// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__1OuC3","totalNumber":"styles_totalNumber__24lIj","pageSize":"styles_pageSize__3y4ZF","dropdown":"styles_dropdown__3jGd5"};